import Button from '@rio-cloud/rio-uikit/Button';
import classnames from 'classnames';
import { useEffect } from 'react';

import { ProductTypedFormattedMessage } from '../../../common/product/ProductTypedFormattedMessage';
import { ProductType } from '../../../common/product/product';
import { safeDataLayerPush } from '../../../common/utils/googleTagManagerWrapper';
import { getServiceOverviewAutoTrackingKey } from '../serviceOverviewTracking';
import { openCheckoutPopup } from '../services/checkoutService';
import { GtmPromotion, getGtmPromotionViewEvent } from '../services/gtmPromotion';
import type { ServiceOverviewItem } from '../types';

interface Props {
    service: ServiceOverviewItem;
    level?: string;
    isPrimary: boolean;
}

export const AddMoreButton = (props: Props) => {
    const { level, service, isPrimary } = props;
    const { sku } = service;
    useEffect(() => {
        safeDataLayerPush(() => getGtmPromotionViewEvent(GtmPromotion.customerCenterAddMore));
    }, [true]);

    const { callback, checkoutUrl } = openCheckoutPopup(sku, GtmPromotion.customerCenterAddMore, level);

    return (
        <Button
            as='a'
            className={classnames('addMore btn btn-default', isPrimary && 'btn-primary')}
            href={checkoutUrl}
            onClick={callback}
            autoTrackingKey={getServiceOverviewAutoTrackingKey(
                service.productType === ProductType.USER_BASED
                    ? 'marketplace.myServices.users.addMore'
                    : 'marketplace.myServices.assets.addMore',
                service.productName ?? service.sku
            )}
        >
            <span className='rioglyph rioglyph-plus' aria-hidden={true} />
            <ProductTypedFormattedMessage
                productType={service.productType}
                assetBasedId={'marketplace.myServices.assets.addMore'}
                userBasedId={'marketplace.myServices.users.addMore'}
            />
        </Button>
    );
};
